import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const ContentCtx = createContext({ content: {}, locale: 'es', setLocale: () => {}, refresh: async () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [locale, setLocaleState] = useState(() => localStorage.getItem('modaria_lang') || 'es');
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get('/content');
      setContent(data || {});
    } catch (e) {
      console.error('content load failed', e);
    } finally {
      setLoading(false);
    }
  };

  const setLocale = (l) => {
    setLocaleState(l);
    localStorage.setItem('modaria_lang', l);
    document.documentElement.lang = l;
  };

  useEffect(() => { refresh(); }, []);
  useEffect(() => { document.documentElement.lang = locale; }, [locale]);

  return (
    <ContentCtx.Provider value={{ content, locale, setLocale, refresh, loading }}>
      {children}
    </ContentCtx.Provider>
  );
}

export const useContent = () => useContext(ContentCtx);
